<template>
	<div id="header">
		<div>

			<div class="logo">
				<router-link :to="{ name: 'Home' }">
					<img src="images/logo.png" alt="Armslist Deals">
				</router-link>
			</div>
			
			<div class="rside">
				<div id="nav">
					<ul>
						<li>
							<router-link :to="{ name: 'Tag', params: { tag: 'firearms' } }">FIREARMS</router-link>
							<ul class="submenu">
								<li><router-link :to="{ name: 'Tag', params: { tag: 'handguns' } }">Handguns</router-link></li>
								<li><router-link :to="{ name: 'Tag', params: { tag: 'shotguns' } }">Shotguns</router-link></li>
								<li><router-link :to="{ name: 'Tag', params: { tag: 'rifles' } }">Rifles</router-link></li>
							</ul>
						</li>
						<li><router-link :to="{ name: 'Tag', params: { tag: 'ammunition' } }">Ammo</router-link></li>
						<li><router-link :to="{ name: 'Tag', params: { tag: 'knives' } }">Knives</router-link></li>
						<li>
							<router-link :to="{ name: 'Tag', params: { tag: 'accessories' } }">Accessories</router-link>
							<ul class="submenu">
								<li><router-link :to="{ name: 'Tag', params: { tag: 'holsters' } }">Holsters</router-link></li>
								<li><router-link :to="{ name: 'Tag', params: { tag: 'magazines' } }">Magazines</router-link></li>
								<li><router-link :to="{ name: 'Tag', params: { tag: 'optics' } }">Optics</router-link></li>
								<li><router-link :to="{ name: 'Tag', params: { tag: 'safes' } }">Safes &amp; Storage</router-link></li>
								<li><router-link :to="{ name: 'Tag', params: { tag: 'targets' } }">Shooting Targets</router-link></li>
								<li><router-link :to="{ name: 'Tag', params: { tag: 'accessories' } }">View All</router-link></li>
							</ul>
						</li>
						<li><router-link :to="{ name: 'All' }">All Deals</router-link></li>
					</ul>
				</div>
				<Search />
			</div>

			<div id="nav-mobile">
				<MobileNav 
					:closeOnNavigation="true" 
					:isOpen="isMenuOpen" 
					@openMenu="isMenuOpen = true"
					@closeMenu="isMenuOpen = false"
					right
				>

					<!-------------------------------------------------
						Firearms
					---------------------------------------------------->
					<a href="/firearms" @click.prevent="$router.push({ name: 'Tag', params: { tag: 'firearms' } })">FIREARMS</a>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'handguns' } }">Handguns</router-link>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'shotguns' } }">Shotguns</router-link>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'rifles' } }">Rifles</router-link>

					<!-------------------------------------------------
						Ammo
					---------------------------------------------------->
					<a href="/ammo" @click.prevent="$router.push({ name: 'Tag', params: { tag: 'ammunition' } })">Ammo</a>

					<!-------------------------------------------------
						Accessories
					---------------------------------------------------->
					<router-link :to="{ name: 'Tag', params: { tag: 'accessories' } }">Accessories</router-link>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'magazines' } }">Magazines</router-link>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'holsters' } }">Holsters</router-link>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'optics' } }">Optics</router-link>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'safes' } }">Safes &amp; Storage</router-link>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'targets' } }">Shooting Targets</router-link>
						<router-link class="sub" :to="{ name: 'Tag', params: { tag: 'accessories' } }">View All</router-link>

					<!-------------------------------------------------
						All Deals
					---------------------------------------------------->
					<a href="/all" @click.prevent="$router.push({ name: 'All' })">All Deals</a>


					<!-------------------------------------------------
						Search
					---------------------------------------------------->
					<div class="srch">
						<Search @searching="isMenuOpen = false" />
					</div>

				</MobileNav>
			</div>

			<!-------------------------------------------------
				Email Capture Modal
			---------------------------------------------------->
			<EmailCapture v-if="showEmailCapture === true" @close="showEmailCapture = false" />

		</div>
	</div>
</template>

<script>
import MobileNav from './MobileNav.vue'
import Search from './Search.vue';
import EmailCapture from './EmailCapture.vue';

//
export default {
	name: "Header",
	mounted() {
		this.maybeShowEmailCapture();
	},
	components: {
		MobileNav,
		Search,
		EmailCapture
	},
	data: function() {
		return {
			isMenuOpen: false,
			showEmailCapture: false
		}
	},
	methods: {
		maybeShowEmailCapture() {
			if( ! window.localStorage.getItem('seenemailcapture') ) {
				setTimeout(() => {
					this.showEmailCapture = true;
					window.localStorage.setItem('seenemailcapture', 1);
				}, 30000);
			}
		}
	}
};
</script>

<style lang="scss">
#header {
	position: relative;
	background-color: #000;
	// background-image: url('../../public/images/bg-body.png');
	background-repeat: no-repeat;
	background-size: cover;
	box-shadow: 0px 0px 6.88px 1.12px rgba(1, 1, 1, 0.16);
	margin-bottom: 40px;
	padding: 0 20px;
	z-index: 50;

	max-width: 100%;

	>* {
		position: relative;
		max-width: 1300px;
		height: 110px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.rside {
		display: none;
		position: relative;
		justify-content: flex-end;
		align-items: center;
	}

	.logo {
		a {
			display: block;
			width: 75%;
			max-width: 300px;
		}
	}

	#nav {
		margin-right: 50px;

		>ul {
			position: relative;
			display: flex;
			>li {
				position: relative;
				&:hover {
					ul.submenu {
						display: block;
						min-width: 100%;
					}
				}
			}
		}

		ul.submenu {
			display: none;
			position: absolute;
			top: 35px;
			left: 0;
			background: #000;
			li {
				display: block;
				border-bottom: 1px #e5e0bf solid;
			}
		}

		a {
			display: block;
			margin: 0 10px;
			padding: 10px 15px;
			color: #e5e0bf;
			text-decoration: none;
			text-transform: uppercase;
			white-space: nowrap;
			&:hover {
				color: #d2c15c;
			}
		}
	}

	#nav-mobile {
		.bm-burger-button {
			right: 0 !important;
			left: unset;
			.bm-burger-bars {
				background-color: #fff;
				height: 10%;
			}
		}
		.bm-item-list {
			margin-left: 0;
			a {
				display: block;
				border-bottom: #fff 1px solid;
				padding: 15px 25px;
				color: #fff;
				white-space: nowrap;
				&.sub {
					padding-left: 50px;
				}
			}
		}
	}

	@media ( min-width: 900px ) {
		.logo {
			a {
				width: 300px;
			}
		}
		.rside {
			display: flex;
		}
		#nav-mobile {
			display: none;
		}
	}

}
</style>